import { render, staticRenderFns } from "./tiaoz.vue?vue&type=template&id=04090ae6&scoped=true"
import script from "./tiaoz.vue?vue&type=script&lang=js"
export * from "./tiaoz.vue?vue&type=script&lang=js"
import style0 from "./tiaoz.vue?vue&type=style&index=0&id=04090ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04090ae6",
  null
  
)

export default component.exports